module.exports = __webpack_public_path__ + "32595ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/new/code.png
// module id = 696
// module chunks = 1